// Filters, sort and Load more without page reload (Section Rendering API). The URL follows every change.
const root = document.querySelector('[data-facets-section]');

if (root) {
  const sectionId = root.dataset.sectionId;
  const form = () => root.querySelector('[data-facets-form]');
  let controller;

  const swap = (doc) => {
    const closedGroups = [...root.querySelectorAll('.facets__group')].filter((d) => !d.open).map((d) => d.id);
    doc.querySelectorAll('[data-facet-swap]').forEach((fresh) => {
      root.querySelector(`[data-facet-swap="${fresh.dataset.facetSwap}"]`)?.replaceWith(fresh);
    });
    closedGroups.forEach((id) => { const d = document.getElementById(id); if (d) d.open = false; });
    const freshButton = doc.querySelector('.results__filter-button');
    const button = root.querySelector('.results__filter-button');
    if (freshButton && button) button.textContent = freshButton.textContent;
  };

  const load = async (url) => {
    controller?.abort();
    controller = new AbortController();
    root.querySelector('.results')?.setAttribute('aria-busy', 'true');
    try {
      const target = new URL(url, location.origin);
      target.searchParams.delete('page');
      history.replaceState(null, '', `${target.pathname}${target.search}`);
      target.searchParams.set('section_id', sectionId);
      const html = await (await fetch(target, { signal: controller.signal })).text();
      swap(new DOMParser().parseFromString(html, 'text/html'));
    } catch (err) {
      if (err.name !== 'AbortError') location.href = url;
    } finally {
      root.querySelector('.results')?.removeAttribute('aria-busy');
    }
  };

  const fromForm = () => {
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form())) if (value !== '') params.append(key, value);
    const sort = root.querySelector('[name="sort_by"]');
    if (sort) params.set('sort_by', sort.value);
    return `${location.pathname}?${params}`;
  };

  let timer;
  root.addEventListener('change', (e) => {
    if (!e.target.closest('[data-facets-form]') && e.target.name !== 'sort_by') return;
    clearTimeout(timer);
    timer = setTimeout(() => load(fromForm()), e.target.type === 'number' ? 600 : 150);
  });

  root.addEventListener('submit', (e) => {
    if (!e.target.matches('[data-facets-form]')) return;
    e.preventDefault();
    load(fromForm());
  });

  root.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (link) {
      e.preventDefault();
      load(link.href);
      return;
    }
    const more = e.target.closest('[data-load-more]');
    if (more) {
      e.preventDefault();
      window.Pleassy?.buttonState(more, 'busy');
      const url = new URL(more.href, location.origin);
      url.searchParams.set('section_id', sectionId);
      const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const items = [...doc.querySelectorAll('[data-grid] > li')];
      root.querySelector('[data-grid]')?.append(...items);
      const wrap = doc.querySelector('[data-load-more-wrap]');
      if (wrap) root.querySelector('[data-load-more-wrap]')?.replaceWith(wrap);
      items[0]?.querySelector('.card__title')?.focus({ preventScroll: true });
    }
  });
}
